import { render, staticRenderFns } from "./MaskDetail.vue?vue&type=template&id=6aaf9852&scoped=true&"
import script from "./MaskDetail.vue?vue&type=script&lang=js&"
export * from "./MaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./MaskDetail.vue?vue&type=style&index=0&id=6aaf9852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf9852",
  null
  
)

export default component.exports